import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import Plugins from '../modules/apps/plugins/Plugins'
import {PageTitle} from '../../_metronic/layout/core'
import {ModeratorDashboard} from '../pages/dashboard/ModeratorDashboard'

const PrivateRoutes = () => {
  /*================================ Lazy Loading start=========================================*/

  const ProfilePage = lazy(() => import('../modules/apps/profile/ProfilePage'))
  const AdminUserPage = lazy(() => import('../modules/apps/admin-user-profile/AdminProfilePage'))

  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  const StoresPage = lazy(() => import('../modules/apps/store-management/StorePage'))
  const OffersPage = lazy(() => import('../modules/apps/offers-management/OffersPage'))

  const StoreProfilePage = lazy(() => import('../modules/apps/store-profile/ProfilePage'))

  const AdminUsersPage = lazy(() => import('../modules/apps/admin-user-management/AdminUsersPage'))

  const UserOrders = lazy(() => import('../modules/apps/user-orders/UserOrders'))

  const DailyAnalyticsManagement = lazy(
    () => import('../modules/apps/analytics-management/DailyAnalyticsManagement')
  )
  const PackageAnalyticsManagement = lazy(
    () => import('../modules/apps/analytics-management/PackageAnalyticsManagement')
  )

  const SupportSystem = lazy(() => import('../modules/apps/support-system/SupportSystem'))
  const SupportChatDrawer = lazy(() => import('../modules/apps/support-system/SupportChatDrawer'))
  const Graphs = lazy(() => import('../modules/apps/analytics-management/GraphsAnalytics'))
  const InvoiceManagement = lazy(
    () => import('../modules/apps/invoice-management/InvoiceManagement')
  )

  /*================================ Lazy Loading end=========================================*/

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='mdashboard' element={<ModeratorDashboard />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/store-management/*'
          element={
            <SuspensedView>
              <StoresPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/offer-management/*'
          element={
            <SuspensedView>
              <OffersPage />
            </SuspensedView>
          }
        />

        <Route
          path='apps/admin-user-management/*'
          element={
            <SuspensedView>
              <AdminUsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/users-profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/stores-profile/*'
          element={
            <SuspensedView>
              <StoreProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/admin-user/users-profile/*'
          element={
            <SuspensedView>
              <AdminUserPage />
            </SuspensedView>
          }
        />
        <Route
          path='plugins/*'
          element={
            <SuspensedView>
              <Plugins />
            </SuspensedView>
          }
        />
        <Route path='user-media/*' element={<SuspensedView></SuspensedView>} />

        <Route
          path='user-order'
          element={
            <SuspensedView>
              <PageTitle>User Orders</PageTitle>
              <UserOrders />
            </SuspensedView>
          }
        />
        <Route
          path='support-system'
          element={
            <SuspensedView>
              <PageTitle>Support System</PageTitle>
              <SupportSystem />
            </SuspensedView>
          }
        />
        <Route
          path='support_chat/:supportId/user/:userId'
          element={
            <SuspensedView>
              <PageTitle>Support Chat</PageTitle>
              <SupportChatDrawer />
            </SuspensedView>
          }
        />
        <Route
          path='analytics/daily-analytics'
          element={
            <SuspensedView>
              <PageTitle>Daily Analytics Management</PageTitle>
              <DailyAnalyticsManagement />
            </SuspensedView>
          }
        />
        <Route
          path='analytics/package-analytics'
          element={
            <SuspensedView>
              <PageTitle>Packages Page Analytics</PageTitle>
              <PackageAnalyticsManagement />
            </SuspensedView>
          }
        />
        <Route
          path='analytics/graphs-analytics'
          element={
            <SuspensedView>
              <Graphs />
            </SuspensedView>
          }
        />
        {/* <Route
          path='invoice-management'
          element={
            <SuspensedView>
              <PageTitle>Invoice Management</PageTitle>
              <InvoiceManagement />
            </SuspensedView>
          }
        /> */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
